import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import { closeFormModal, openViewModal } from "../../store/reducers/schools/schools.reducer";
import { useEffect, useState } from "react";
import {
  createSchoolThunk,
  getSchoolsThunk,
  updateSchoolThunk,
  getSchoolByIdThunk,
} from "../../store/reducers/schools/schools.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import { toast } from 'react-toastify';

const SchoolFormModal = () => {
  const dispatch = useDispatch();
  const { formModalOpen, formMode, selectedSchool, formLoading, formError, page, search } =
    useSelector((state) => state.schools);

  const [formData, setFormData] = useState({
    nombre: "",
    siglas: "",
    tipo: "",
    publica: true,
  });

  useEffect(() => {
    if (formMode === "edit" && selectedSchool) {
      setFormData({
        nombre: selectedSchool.nombre,
        siglas: selectedSchool.siglas,
        tipo: selectedSchool.tipo,
        publica: selectedSchool.publica,
      });
    } else {
      setFormData({
        nombre: "",
        siglas: "",
        tipo: "",
        publica: true,
      });
    }
  }, [formMode, selectedSchool, formModalOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formMode === "create") {
      const result = await dispatch(createSchoolThunk(formData));
      if (result.meta.requestStatus === "fulfilled") {
        const createdId = result.payload.data.id;
        // Recargar la lista después de crear
        dispatch(getSchoolsThunk({ page: 1, search: "" }));
        toast.success('Escuela creada exitosamente');
        // Abrir modal de vista con el nuevo registro
        await dispatch(getSchoolByIdThunk(createdId));
        dispatch(openViewModal());
      }
    } else {
      const result = await dispatch(
        updateSchoolThunk({
          id: selectedSchool.id,
          payload: formData,
        }),
      );
      if (result.meta.requestStatus === "fulfilled") {
        // Recargar la lista después de actualizar
        dispatch(getSchoolsThunk({ page, search }));
        toast.success('Escuela actualizada exitosamente');
        // Abrir modal de vista con el registro actualizado
        await dispatch(getSchoolByIdThunk(selectedSchool.id));
        dispatch(openViewModal());
      }
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title={formMode === "create" ? "Crear nueva escuela" : "Editar escuela"}
      size="md"
    >
      {formLoading ? (
        <Loader
          center
          type="dots"
          text={
            formMode === "create"
              ? "Creando escuela..."
              : "Actualizando escuela..."
          }
        />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Nombre <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="nombre"
              className="form-control"
              value={formData.nombre}
              onChange={handleChange}
              required
              placeholder="Ej: Universidad Nacional Autónoma de México"
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">
              Siglas <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="siglas"
              className="form-control"
              value={formData.siglas}
              onChange={handleChange}
              required
              placeholder="Ej: UNAM"
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">
              Tipo <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="tipo"
              className="form-control"
              value={formData.tipo}
              onChange={handleChange}
              required
              placeholder="Ej: Universidad"
            />
          </div>

          <div className="mb-3">
            <div className="form-check form-switch">
              <input
                type="checkbox"
                name="publica"
                className="form-check-input"
                id="publica"
                checked={formData.publica}
                onChange={handleChange}
              />
              <label className="form-check-label fw-medium" htmlFor="publica">
                ¿Es pública?
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              {formMode === "create" ? "Crear" : "Guardar cambios"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default SchoolFormModal;
